import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCriteriaGroup } from "../../services/criteriaGroup";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useDeleteCriteriaGroup = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteCriteriaGroup,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["criteria-groups"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Criteria group deleted successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useDeleteCriteriaGroup;